$(document).ready(function() {
    $('.js-scroll-to-next-section').click(function() {
        // Determine the height of the header
        var headerHeight = $('.js-heading-links').outerHeight();

        // Start from the current section
        var currentSection = $(this).closest('section');

        // Find the next section or .wp-block-group, whichever comes first
        var nextTarget = currentSection.nextAll('section, .wp-block-group').first();

        if (nextTarget.length) {
            // Calculate the position to scroll to, accounting for the header height
            var scrollTo = nextTarget.offset().top - headerHeight - 40;

            // Animate scroll to the next target
            $('html, body').animate({
                scrollTop: scrollTo
            }, 800); // Adjust the duration (800ms) to your liking
        }
    });
});